import {
    JsonNotificationIdentifierModel,
    NotificationIdentifierModel,
    NotificationIdentifierModelFromJson,
} from './notification-identifier.model';
import { JsonStatusModel, StatusModel, StatusModelFromJson } from './status.model';

export class NotificationStatusModel {
    public constructor(
        public notificationId: NotificationIdentifierModel,
        public escalated = false,
        public cancelled = '',
        public unread = true,
        public paused = false,
        public status: StatusModel[] = [],
    ) {}

    public toJSON(): unknown {
        return {
            notificationId: this.notificationId.toJSON(),
            escalated: this.escalated,
            cancelled: this.cancelled,
            unread: this.unread,
            paused: this.paused,
            status: this.status,
        };
    }
}

export class NotificationStatusModelFromJson extends NotificationStatusModel {
    public constructor(data: JsonNotificationStatusModel) {
        super(
            new NotificationIdentifierModelFromJson(data.notificationId),
            data.escalated,
            data.cancelled,
            data.unread,
            data.paused,
            data.status.map((currentModel) => new StatusModelFromJson(currentModel)),
        );
    }
}

export interface JsonNotificationStatusModel {
    notificationId: JsonNotificationIdentifierModel;
    escalated: boolean;
    cancelled: string;
    unread: boolean;
    paused: boolean;
    status: JsonStatusModel[];
}
